













import { Component, Mixins, Prop } from "vue-property-decorator";
import { DateInputMethodKinds } from "../../../../domain/document/inputMethodKinds";
import { DisableableMixin } from "../../../system/mixins";
import DateObject from "../../../document/editor/objects/DateObject.vue";
import DateInputMethodSelector from "./DateInputMethodSelector.vue";
import InputMethodEditCheckBox from "./InputMethodEditCheckBox.vue";

@Component({
  components: {
    DateInputMethodSelector,
    InputMethodEditCheckBox,
  }
})
export default class DateInputMethodEditor extends Mixins(DisableableMixin) {
  @Prop()
  source: DateObject;

  get selected(): DateInputMethodKinds {
    return this.source.inputMethodKind;
  }

  set selected(value: DateInputMethodKinds) {
    this.source.inputMethodKind = value;
  }
}
